// extracted by mini-css-extract-plugin
export default {"container":"orderManagement_container__QJ6qp","header":"orderManagement_header__UL4zM","filter":"orderManagement_filter__Qjgta","tableFooter":"orderManagement_tableFooter__GFMHx"};